import React from 'react';
import BookmarksOutlinedIcon from '@mui/icons-material/BookmarksOutlined';
import { useTranslation } from 'react-i18next';

import scss from './EmptyFavorites.module.scss';

function EmptyFavorites() {
  const { t } = useTranslation('studio');

  return (
    <div className={scss.emptyGallery}>
      <BookmarksOutlinedIcon className={scss.icon} />
      <span className={scss.label}>{t('emptyFavoriteMedia')}</span>
      <span className={scss.subLabel}>{t('emptyFavoriteMediaDescription')}</span>
    </div>
  );
}

export default EmptyFavorites;
